const VisionAndValue = () => {
  return (
    <div class="gdlr-core-pbf-wrapper vision-and-value">
      <div class="gdlr-core-pbf-background-wrap"></div>
      <div class="gdlr-core-pbf-background-wrap" style={{ top: "10px" }}>
        <div class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js section-background"></div>
      </div>
      <div class="gdlr-core-pbf-wrapper-content gdlr-core-js ">
        <div class="gdlr-core-pbf-wrapper-container clearfix gdlr-core-container">
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30 gdlr-core-column-first"
            id="gdlr-core-column-6"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js gdlr-core-column-extend-left"
              data-sync-height="height-img"
            >
              <div class="gdlr-core-pbf-background-wrap">
                <div
                  class="gdlr-core-pbf-background gdlr-core-parallax gdlr-core-js second-bg"
                  data-parallax-speed="0"
                ></div>
              </div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js  gdlr-core-sync-height-content"></div>
            </div>
          </div>
          <div
            class="gdlr-core-pbf-column gdlr-core-column-30"
            id="gdlr-core-column-7"
          >
            <div
              class="gdlr-core-pbf-column-content-margin gdlr-core-js"
              style={{
                margin: "0px",
                padding: "100px 0px 60px 75px",
                height: "522.188px",
              }}
              data-sync-height="height-img"
            >
              <div class="gdlr-core-pbf-background-wrap"></div>
              <div class="gdlr-core-pbf-column-content clearfix gdlr-core-js  gdlr-core-sync-height-content">
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-title-item gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-title-item-caption-top gdlr-core-item-pdlr"
                    style={{ paddingBottom: "35px" }}
                  >
                    <span class="gdlr-core-title-item-caption gdlr-core-info-font gdlr-core-skin-caption">
                      <span class="gdlr-core-title-item-caption-prefix"></span>
                      COMPLETE HONESTY AND TRANSPARENCY
                    </span>
                    <div class="gdlr-core-title-item-title-wrap ">
                      <h3 class="gdlr-core-title-item-title gdlr-core-skin-title ">
                        Our Vision and Values
                        <span class="gdlr-core-title-item-title-divider gdlr-core-skin-divider"></span>
                      </h3>
                    </div>
                  </div>
                </div>
                <div class="gdlr-core-pbf-element">
                  <div
                    class="gdlr-core-icon-list-item gdlr-core-item-pdlr gdlr-core-item-pdb clearfix  gdlr-core-left-align gdlr-core-style-1"
                    style={{ paddingBottom: "20px" }}
                  >
                    <ul>
                      <li
                        class=" gdlr-core-skin-divider clearfix"
                        style={{ marginBottom: "17px" }}
                      >
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content">
                            Premium services that exceed expectations
                          </span>
                        </div>
                      </li>
                      <li
                        class=" gdlr-core-skin-divider clearfix"
                        style={{ marginBottom: "17px" }}
                      >
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content">
                            Best-in-class support across all vendors
                          </span>
                        </div>
                      </li>
                      <li
                        class=" gdlr-core-skin-divider clearfix"
                        style={{ marginBottom: "17px" }}
                      >
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content">
                            Competitive pricing for high-quality solutions
                          </span>
                        </div>
                      </li>
                      <li
                        class=" gdlr-core-skin-divider clearfix"
                        style={{ marginBottom: "17px" }}
                      >
                        <div class="gdlr-core-icon-list-content-wrap">
                          <span class="gdlr-core-icon-list-content">
                            Commitment to innovation and growth
                          </span>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VisionAndValue;
